import React , {useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'


import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

import Meta from '../../components/Meta'

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";


export const DeeprootsScreen = ({match, history}) => {

    
    const dispatch = useDispatch()



    const [newModel, setNewModel] = useState("") 

    const [data, setData] = useState([])






    useEffect(() => {
       

    }, [])





    return(
        <div style={{ marginTop: '0px', fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif', background: '#f8f9fa', minHeight: '100vh' }}>
            <Meta title={'DeepRoots'} description={'A Deep Learning library to build and train simple neural networks.'} />

            {/* Hero Section */}
            {/* <section style={{
                background: 'linear-gradient(90deg, #f0f2f2 60%, #e6e6fa 100%)',
                padding: '48px 0 32px 0',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
                marginBottom: 32,
            }}>
                <h1 style={{
                    fontWeight: 800,
                    fontSize: '2.4rem',
                    color: '#0C0854',
                    letterSpacing: '0.01em',
                    marginBottom: 12,
                    fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif',
                }}>DeepRoots</h1>
                <h4 style={{
                    color: '#6b0752',
                    fontWeight: 500,
                    marginBottom: 0,
                    fontSize: '1.2rem',
                }}>
                    DeepRoots is an open-source neural network library built in python designed to make setting up and training neural networks easy for beginners.
                </h4>
            </section> */}

            <Container fluid style={{ width: '100vw', maxWidth: '100vw', padding: 0, margin: 0 }}>
                <Row className="justify-content-center" style={{ margin: 0 }}>
                    <Col xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 0 }}>
                       
                    <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                    <h1 style={{
                    fontWeight: 800,
                    fontSize: '2.4rem',
                    color: '#0C0854',
                    letterSpacing: '0.01em',
                    marginBottom: 12,
                    fontFamily: 'Roboto, Inter, "Open Sans", Arial, sans-serif',
                }}>DeepRoots</h1>
                <p className='h4' style={{
                    color: '#6b0752',
                    fontWeight: 500,
                    marginBottom: 0,
                    fontSize: '1.2rem',
                }}>
                    DeepRoots is an open-source neural network library built in python designed to make setting up and training neural networks easy for beginners.
                </p>
                        </Card>
                       
                        {/* Getting Started Card */}
                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Getting Started</h2>
                            <p className='h5'>You can find DeepRoots on github at <a style={{ color: '#7b2ff7' }} href='https://github.com/pixagan/DeepRoots'>https://github.com/pixagan/DeepRoots</a></p>
                            <SyntaxHighlighter language='bash'>
                                git clone https://github.com/pixagan/deeproots.git
                            </SyntaxHighlighter>
                            <p className='h5'>Install the dependencies</p>
                            <SyntaxHighlighter language='bash'>
                                pip install -r requirements.txt
                            </SyntaxHighlighter>
                            <p className='h5'>Install the package locally using pip</p>
                            <SyntaxHighlighter language='bash'>
                                pip install -e .
                            </SyntaxHighlighter>
                        </Card>

                        {/* Creating a Multi Layer Perceptron Card */}
                        <Card style={{ width: '96vw', maxWidth: 1100, marginBottom: '18px', border: 'none', borderRadius: 18, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', padding: '28px' }}>
                            <h2 style={{ fontWeight: 700, color: '#0C0854', marginBottom: 18, fontSize: '1.5rem' }}>Creating a Multi Layer Perceptron</h2>
                            {isMobile ? (
                                <img src={"/DeepRootsExampleNet.jpg"} alt={"DeepRoots Example"} style={{ width: '70vw' }} />
                            ) : (
                                <img src={"/DeepRootsExampleNet.jpg"} alt={"DeepRoots Example"} style={{ width: '30vw' }} />
                            )}
                            <hr />
                            <p className='h5'>A Simple Dataset</p>
                            <SyntaxHighlighter language='python'>
                                X_train = np.array([[1,2,3], [4,5,6]])
                                y_train = np.array([[1,0], [0,1]])  
                            </SyntaxHighlighter>
                            <p className='h5'>Create the tanh Layers</p>
                            <SyntaxHighlighter language='python'>
                                L1 = LayerScalar(3, 4, 'tanh')
                                L2 = LayerScalar(4, 2, 'tanh')
                            </SyntaxHighlighter>
                            <p className='h5'>Creating the Network</p>
                            <SyntaxHighlighter language='python'>
                                layer_list = [L1, L2]
                                net = NNScalar(layer_list)
                            </SyntaxHighlighter>
                            <p className='h5'>Setting up a loss function</p>
                            <SyntaxHighlighter language='python'>
                                lossfun = SoftmaxCrossEntropy()
                            </SyntaxHighlighter>
                            <p className='h5'>Picking up a data</p>
                            <SyntaxHighlighter language='python'>
                                x_act = X_train[0,:]
                                y_act = y_train[0,:]
                            </SyntaxHighlighter>
                            <p className='h5'> Forward pass through the network</p>
                            <SyntaxHighlighter language='python'>
                                y_pred      = net.forward(x_act)
                            </SyntaxHighlighter>
                            <p className='h5'>Evaluating the loss function</p>
                            <SyntaxHighlighter language='python'>
                                loss, dL_dy = lossfun.eval(y_act, y_pred)
                            </SyntaxHighlighter>
                            <p className='h5'>Backward pass through the network</p>
                            <SyntaxHighlighter language='python'>
                                net.backward(dL_dy)
                            </SyntaxHighlighter>
                            <p className='h5'>Getting the gradients</p>
                            <SyntaxHighlighter language='python'>
                                grad = net.get_gradient()
                            </SyntaxHighlighter>
                            <p className='h5'>Getting the weights</p>
                            <SyntaxHighlighter language='python'>
                                weights = net.get_weights()
                                print("weights ", weights)
                            </SyntaxHighlighter>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default DeeprootsScreen


